import React, { Component, Fragment } from "react";
import {
  Segment,
  Dimmer,
  Loader,
  Table,
  Label,
  Button,
  Icon
} from "semantic-ui-react";
import fire from "../../config/config";
import * as moment from "moment";

export default class Packages extends Component {
  state = {
    loading: true,
    packages: []
    //activated: false
  };

  componentDidMount() {
    fire
      .database()
      .ref("packages")
      .on("value", snap => {
        let data = snap.val();
        //console.log("data:", data);
        let packages = [];
        for (let i in data) {
          packages.push({ ...data[i], key: i });
        }
        packages.reverse();
        this.setState({ packages, loading: false });
      });
  }

  activate(key, userId, pckg) {
    //console.log("key act:", key);
    //activate the guy
    var time = new Date().getTime();
    fire
      .database()
      .ref("/packages/" + key)
      .update({
        activated: true,
        activatedAt: time
      })
      .then(() => {
        fire
          .database()
          .ref(`/users/${userId}/`)
          .update({
            activated: time //replace the time that the last package has been updated to
          })
          .then(() => {
            fire
              .database()
              .ref("/duePayments/")
              .push({
                btc_address: pckg.btc_address,
                tbc_address: pckg.tbc_address,
                name: pckg.purchasedBy,
                email: pckg.email,
                date: time,
                package: pckg.pckg,
                done: false,
                payRemaining: 6
              })
              .then(() => {
                //push the activated packages in the user history
                fire
                  .database()
                  .ref(`/users/${userId}/history/`)
                  .push({
                    pckg: pckg.pckg,
                    time: time,
                    activated: true,
                    activatedAt: time
                  });
              });
          });
      });
  }

  render() {
    const { loading, packages } = this.state;

    if (loading) {
      return (
        <Dimmer active inverted>
          <Loader size="large">Loading</Loader>
        </Dimmer>
      );
    }
    return (
      <Segment>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Email</Table.HeaderCell>
              <Table.HeaderCell>Package</Table.HeaderCell>
              <Table.HeaderCell>Bought on</Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {packages.map((pckg, index) => (
              <Table.Row key={index}>
                <Table.Cell>
                  <Label ribbon style={{ fontSize: 15 }}>
                    {pckg.purchasedBy}
                  </Label>
                </Table.Cell>
                <Table.Cell>{pckg.email}</Table.Cell>
                <Table.Cell>{pckg.pckg}</Table.Cell>
                <Table.Cell>{moment(pckg.time).format("LLLL")}</Table.Cell>
                {/*place for status*/}
                <Table.Cell>
                  {pckg.activated ? (
                    <Fragment>active</Fragment>
                  ) : (
                    <Button
                      animated
                      onClick={() => this.activate(pckg.key, pckg.userId, pckg)}
                    >
                      <Button.Content visible>Activate</Button.Content>
                      <Button.Content hidden>
                        <Icon name="arrow right" />
                      </Button.Content>
                    </Button>
                  )}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/AdminDash/Packages.js